<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'DeviceDetail',
})
</script>
<template>
  <a-card  :tab-list="tabList"
    :active-tab-key="key"
    @tabChange="onTabChange">
    <template v-if="dataSource">
    <a-descriptions v-if="key==0" bordered>
      <a-descriptions-item v-for="(item,i) in deviceData" :key="i" :label="item.name">
       <span class="text-bolder" v-if="(item.data&&item.data.length>0)||item.domtype=='select'">
        {{  AutoData.FindName(deviceData,i,item.value) }}
      </span>
        <a-switch v-else-if="item.domtype=='switch'||typeof(item.value)=='boolean'" :checked="item.value"></a-switch>
        <span class="text-bolder" v-else>{{ item.value}}</span>
        <p v-if="i=='DriverId'&&item.Driver">{{ item.Driver.FileName }}</p>
      </a-descriptions-item>
      <a-descriptions-item label="所属设备组" v-if="dataSource.DeviceGroup">{{ dataSource.DeviceGroup.DeviceGroupName }}</a-descriptions-item>
    </a-descriptions>
    <a-descriptions v-if="key==1" bordered>
      <a-descriptions-item v-for="(item,i) in dataSource.DeviceConfigs" :key="i" :label="item.Description?item.Description:item.DeviceConfigName">
         <span class="text-bolder">{{ item.Value }}</span>
      </a-descriptions-item>
    </a-descriptions>
    <template v-if="key==2">
        <a-descriptions  bordered  v-for="(item,i) in dataSource.DeviceVariables" :key="i" :title="item.Description">
           <a-descriptions-item v-for="(it,u) in AutoData.InitValue(varmodel,item,varcolumns)" :key="u" :label="it.name">
            	<span class="text-bolder" v-if="(item.data&&item.data.length>0)||item.domtype=='select'">
            {{  AutoData.FindName(AutoData.InitValue(varmodel,item),u,it.value) }}
            </span>
            <a-switch v-else-if="item.domtype=='switch'||typeof(it.value)=='boolean'" :checked="it.value"></a-switch>
            <template v-else-if="u=='AlarmExpressions'&&item.AlarmExpressions">
              <p v-for="(t,z) in JSON.parse(item.AlarmExpressions)">
                  <span class="text-yellow" v-if="z==0">警示</span>
                  <span class="text-orange" v-else-if="z==1">危险</span>
                  <span class="text-red" v-else-if="z==2">严重</span>
                  <span class="margin-left text-bolder">{{ t[0] }} - {{t[1] }}</span>
              </p>
            </template>
            <span class="text-bolder" v-else>{{ it.value}}</span>
          </a-descriptions-item>
        </a-descriptions>
    </template>
    </template>

  </a-card>
</template>
<script setup lang="ts" name="DeviceDetail">
import api from '@/utils/http/service'
import {onMounted,defineProps,ref} from 'vue'
import { PlusOutlined,EditOutlined,DeleteOutlined,ContainerOutlined} from '@ant-design/icons-vue'
import { AutoData } from '@/utils/util'
import { Switch } from 'ant-design-vue'
import Driver from '../driver.vue'
import OtherSettings from '@/components/SettingDrawer/components/OtherSettings.vue'

  const props=defineProps({
    DeviceId:{type:Number,required:true},
    auth:{type:Object,default:()=>{return {see:1,creating:1,edit:1,del:1,agent:0}}}
  })


  const devicemodel=ref<any>({})//原始数据类型
  const deviceData=ref<object>({})
  const varmodel=ref<any>({})//原始数据类型
  const confmodel=ref<any>({})//原始数据类型
  const key=ref<number>(0)
  const devicecolumns=ref<Array>(["DeviceNo","DeviceName","Description","DriverId","AutoStart",'CgUpload','CmdPeriod','DeviceTypeEnum','DeviceGroupId','CreateTime','CreateBy','UpdateTime','UpdateBy'])
  const confcolumns=ref<Array>();
  const varcolumns=['Name','Description','Method','IsTrigger','IsUpload', 'Expressions','AlarmExpressions','ProtectType']
  const tabList:Array=[
    {key: 0,tab: '设备',data:[]},
    {key: 1,tab: '配置',data:[]},
    {key: 2,tab: '变量',data:[]},
  ]

  onMounted(()=>{
    api.device.model(props.DeviceId).then(res=>{
      if(res.state==1){
        devicemodel.value=AutoData.InitModel(res.data)
      }
      api.devicevar.model(props.DeviceId).then(ref=>{
        if(ref.state==1){
            varmodel.value=AutoData.InitModel(ref.data)
        }
        api.deviceconf.model(props.DeviceId).then(rev=>{
          if(rev.state==1){
              confmodel.value=AutoData.InitModel(rev.data)
          }
          getList()
        })
      })
    })
  })

  const loading=ref<boolean>(false)
  const dataSource=ref<object>({})
  const getList=():void=>{
    loading.value=true
      api.device.get(props.DeviceId).then(res => {
        res.data.DeviceVariables.forEach(e => {
            if(e.ExtendData){
              var ext=JSON.parse(e.ExtendData)
              for(var k in ext){
                e['ExtendData___'+k]=ext[key]
              }
            }
        });
        loading.value=false
        deviceData.value= AutoData.InitValue(devicemodel.value,res.data,devicecolumns.value)
        dataSource.value=res.data
      })
  }
  const onTabChange = (value: number) => {
    key.value=value
  };

</script>
